import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  LOAD_TEMPLATE_DETAIL,
  LOAD_TEMPLATE_DETAIL_SUCCESS,
  LOAD_TEMPLATE_DETAIL_ERROR,
} from './constants';
import { makeSelectProfile } from '~/containers/AuthProvider/selectors';
import templateService from '~/services/templateService';
import { USER_ROLES } from '~/config';

function* loadTemplateDetail(action) {
  try {
    const profileUser = yield select(makeSelectProfile());

    const { template, tags } = yield call(templateService.loadTemplateDetail, {
      templateID: action.payload.templateID,
      role: profileUser.role || USER_ROLES.USER,
    });

    yield put({
      type: LOAD_TEMPLATE_DETAIL_SUCCESS,
      payload: {
        templateDetail: template,
        tags: tags,
      },
    });
  } catch (error) {
    yield put({ type: LOAD_TEMPLATE_DETAIL_ERROR, payload: error });
  }
}

export default function* templatePreviewSaga() {
  yield takeLatest(LOAD_TEMPLATE_DETAIL, loadTemplateDetail);
}
